import React, { useState } from 'react';
import { Form, Input, Button, Row, Col, message } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import '../../styles/LoginForm.css'; // Keep using the same CSS file
import { useNavigate } from 'react-router-dom';
import { forgotPasswordService } from '../../services/AuthService'; // New service

const ForgotPasswordForm = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);

    try {
      const { email } = values;
    const response = await forgotPasswordService(email); // Call password reset service
    const { success, message: responseMessage } = response;

    if (success) {
      message.success(responseMessage || 'Reset instructions sent to your email!');
      navigate('/login'); // Redirect to login after successful request
    } else {
      message.error(responseMessage || 'Failed to send reset email. Please try again.');
    }
      
     // message.success('Reset instructions sent to your email!');
      //navigate('/login'); // Redirect to login after successful request
    } catch (error) {
      console.error('Reset error:', error);
      message.error('Failed to send reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Row justify="center" align="middle" className="login-form-container">
      <Col>
        <Form
          name="reset_form"
          className="login-form"
          onFinish={onFinish}
        >
          <div className="logo-container">
            <img src="/logo.png" alt="logo" className="logo-auth" />
          </div>
          
          <Form.Item
            name="email"
            rules={[
              { required: true, message: 'Please enter your email!' },
              { type: 'email', message: 'Invalid email format!' },
            ]}
          >
            <Input 
              prefix={<UserOutlined className="site-form-item-icon" />} 
              placeholder="Email" 
              size="large" 
            />
          </Form.Item>

          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              className="login-form-button" 
              size="large" 
              loading={loading}
              block
            >
              Reset Password
            </Button>
          </Form.Item>

          <Row justify="center">
            <p>Remember your password? </p>
            <p 
              style={{ color: '#1890ff', cursor: 'pointer', marginLeft: '5px' }}
              onClick={() => navigate('/login')}
            >
              Log In
            </p>
          </Row>
        </Form>
      </Col>
    </Row>
  );
};

export default ForgotPasswordForm;